var _metadata, _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem40Ar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata65"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs63"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, "\n    .st1{fill:#b3b3b3}.st2{fill:#595959}.st3{fill:#fff}.st4{font-family:'Arial-BoldMT'}.st5{font-size:16.3971px}.st6{fill:#369;fill-opacity:.502}.st7{font-family:'ArialMT'}.st8{font-size:11.4815px}.st9{fill:#000}\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    },
    id: "path4"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 43.2H84.8c.1 0 1.2 1.9 3.2 5.7 2.1 3.8 4.4 9.6 7.1 17.2s5 17.2 7.1 28.5c2 11.4 3.1 24.7 3.2 39.8-.1 15.1-1.2 28.4-3.2 39.8-2.1 11.4-4.4 21-7.1 28.6-2.7 7.7-5 13.4-7.1 17.2-2 3.9-3.1 5.8-3.2 5.8h33.7c.1 0 1.2-1.9 3.2-5.8 2.1-3.8 4.4-9.6 7.1-17.2 2.7-7.7 5-17.2 7.1-28.6 2-11.4 3.1-24.7 3.2-39.8-.1-15.1-1.2-28.4-3.2-39.8-2.1-11.4-4.4-20.9-7.1-28.5-2.7-7.7-5-13.4-7.1-17.2-2.1-3.8-3.1-5.7-3.2-5.7z",
    className: "st1",
    id: "path6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.4 65.9c-2.7-7.7-5.1-13.4-7.1-17.3-2.1-3.9-3.2-5.9-3.3-5.9l-.2-.2H83.3l.7 1.1c0-.1.1.1.4.4.6.9 2 3.4 4.1 7.7 2.1 4.3 4.3 10.2 6.8 17.8 2.5 7.5 4.6 16.7 6.5 27.6s2.8 23.4 2.8 37.5c-.1 15.1-1.2 28.4-3.2 39.7-2 11.4-4.3 20.8-7 28.4-1.3 3.8-2.6 7.2-3.8 10s-2.4 5.2-3.3 7.1c-1 1.9-1.8 3.4-2.4 4.4-.2.4-.4.7-.5 1.1l-.4.2-.7 1.3h35.5l.2-.4c.1-.1 1.2-2 3.3-5.9 2-3.9 4.4-9.7 7.1-17.3 2.7-7.7 5.1-17.2 7.1-28.7 2.1-11.4 3.2-24.7 3.3-39.9-.1-15.2-1.2-28.5-3.3-39.9-2-11.6-4.4-21.1-7.1-28.8m-7.3-14.3c2.1 4.3 4.4 10.2 6.9 17.8 2.5 7.5 4.6 16.7 6.5 27.6s2.8 23.4 2.8 37.5c-.1 15.1-1.2 28.4-3.2 39.7-2.1 11.4-4.5 20.8-7.2 28.4-1.3 3.8-2.5 7.2-3.7 10-1.2 2.9-2.3 5.2-3.2 7.1-1 1.9-1.8 3.4-2.4 4.4-.3.4-.5.7-.7 1.1h-32c1-1.5 2.5-4.5 4.6-9s4.4-10.6 6.7-18.2c2.4-7.6 4.4-16.7 6.1-27.2 1.7-10.6 2.6-22.7 2.6-36.3-.1-13.4-.9-25.4-2.6-36-1.6-10.5-3.6-19.5-6-27.1-2.3-7.6-4.5-13.7-6.6-18.2-2.1-4.6-3.7-7.7-4.7-9.3h31.9c.7.9 2.1 3.5 4.2 7.7z",
    id: "path8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.9 43.2h-33.5c.1 0 1.2 1.9 3.2 5.7 2.1 3.8 4.4 9.6 7.1 17.2 2.7 7.7 5 17.2 7.1 28.5 2 11.4 3.1 24.7 3.2 39.8-.1 15.1-1.2 28.4-3.2 39.8-2.1 11.4-4.4 21-7.1 28.6-2.7 7.7-5 13.4-7.1 17.2-2 3.9-3.1 5.8-3.2 5.8h33.5c.1 0 1.2-1.9 3.3-5.8 2-3.8 4.4-9.6 7.1-17.2 2.7-7.7 5.1-17.2 7.1-28.6 2.1-11.4 3.2-24.7 3.3-39.8-.1-15.1-1.2-28.4-3.3-39.8-2-11.4-4.4-20.9-7.1-28.5-2.7-7.7-5.1-13.4-7.1-17.2-2.1-3.8-3.2-5.7-3.3-5.7z",
    className: "st2",
    id: "path10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163 65.9c-2.7-7.7-5.1-13.4-7.1-17.3-2.1-3.9-3.2-5.9-3.3-5.9l-.2-.2h-35.5l.7 1.1c.1-.1.1.1.2.4.7.9 2.1 3.4 4.2 7.7 2.1 4.3 4.4 10.2 6.9 17.8 2.5 7.5 4.6 16.7 6.5 27.6s2.8 23.4 2.8 37.5c-.1 15.1-1.2 28.4-3.2 39.7-2.1 11.4-4.5 20.8-7.2 28.4-1.3 3.8-2.5 7.2-3.7 10s-2.3 5.2-3.2 7.1c-1 1.9-1.8 3.4-2.4 4.4-.3.4-.5.7-.7 1.1-.1.1-.1.2-.2.2l-.7 1.3h35.5l.2-.4c.1-.1 1.2-2 3.3-5.9 2-3.9 4.4-9.7 7.1-17.3 2.7-7.7 5.1-17.2 7.1-28.7 2.1-11.4 3.2-24.7 3.3-39.9-.1-15.2-1.2-28.5-3.3-39.9-2-11.6-4.3-21.1-7.1-28.8m-7.3-14.3c2.1 4.3 4.4 10.2 6.9 17.8 2.5 7.5 4.6 16.7 6.5 27.6 1.9 10.9 2.9 23.4 2.9 37.5-.1 15.1-1.2 28.4-3.2 39.7-2.1 11.4-4.5 20.8-7.2 28.4-1.3 3.8-2.5 7.2-3.7 10-1.2 2.9-2.3 5.2-3.2 7.1-1 1.9-1.8 3.4-2.4 4.4-.3.4-.5.7-.7 1.1h-32c1-1.5 2.5-4.5 4.6-9s4.4-10.6 6.7-18.2c2.4-7.6 4.4-16.7 6.1-27.2 1.7-10.6 2.6-22.7 2.6-36.3-.1-13.4-.9-25.4-2.6-36-1.6-10.5-3.6-19.5-6-27.1-2.3-7.6-4.5-13.7-6.6-18.2-2.1-4.6-3.7-7.7-4.7-9.3h31.9c.6.9 1.9 3.5 4.1 7.7z",
    id: "path12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text14",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    className: "st3 st4 st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 133.82577,139.47832 h -5.19532 v -1.58594 h 4.52995 q 0,-1.07553 -0.25521,-1.64063 -0.17317,-0.39193 -0.85677,-1.13021 l 0.71094,-1.48568 q 0.65625,0.82943 0.82031,1.29427 0.2461,0.70183 0.2461,2.32423 z m -0.72005,-8.42189 -0.71094,1.32161 -1.47657,-0.76562 0.67448,-1.33073 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 129.26847,139.47832 h -10.52736 v -1.58594 h 7.42839 q -0.92968,-0.72006 -1.56771,-1.1211 -0.79297,-0.5013 -1.44922,-0.72917 -0.73828,-0.25521 -1.49479,-0.25521 -0.46485,0 -0.93881,0.0638 0.26433,-0.67448 0.69271,-1.08464 0.6198,-0.59245 1.56771,-0.59245 0.92969,0 2.19662,0.91146 0.62891,0.45573 2.05079,1.73177 1.10286,0.9935 1.49479,1.07553 h 0.54688 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 119.37913,139.47832 h -1.27604 q -0.6198,0 -0.9935,-0.50131 -0.32812,-0.4375 -0.5013,-1.30338 -0.16406,-0.86589 -0.25521,-2.13282 -0.0547,-1.02995 -0.11849,-2.11459 -0.0547,-1.08463 -0.15495,-1.64062 -0.0911,-0.56511 -0.2552,-0.92058 -0.20053,-0.4375 -0.55599,-0.76563 l 1.12109,-1.76823 q 0.35547,1.09375 0.5013,2.61589 0.0911,0.94792 0.1823,4.48439 0.16406,1.62239 0.47396,2.07812 0.2552,0.38282 0.55599,0.38282 h 1.27604 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 115.09527,139.47832 h -0.72006 q -0.54687,0 -0.96614,-0.14584 -0.41016,-0.15494 -0.83855,-0.48307 -0.38281,0.34635 -0.68359,0.46484 -0.42839,0.16407 -1.2487,0.16407 h -1.1211 q 0,0.83854 -0.40104,1.63151 -0.51953,1.02995 -1.58594,1.63151 -1.33985,0.75652 -3.35417,0.75652 -1.82292,0 -2.78907,-0.63803 -1.0573,-0.70182 -1.0573,-2.15104 0,-0.78386 0.19141,-1.58594 0.19141,-0.80209 0.51953,-1.61329 0.20052,-0.49218 0.69271,-1.51302 l 0.36459,0.16406 q -0.63802,1.31251 -0.84766,2.06902 -0.20052,0.75651 -0.20052,1.38542 0,1.13021 0.80208,1.72266 0.8112,0.58333 2.306,0.58333 1.75,0 3.1263,-0.61068 1.71355,-0.75651 1.71355,-2.11459 0,-0.91146 -0.33724,-1.73177 -0.26432,-0.64714 -0.7474,-1.23958 l 0.75651,-1.8685 q 0.45573,0.7474 0.6198,1.32162 0.22786,0.8112 0.22786,2.21485 h 1.1211 q 0.86588,0 1.23047,-0.26433 0.31901,-0.22786 0.31901,-0.70182 0,-0.26432 -0.0365,-0.52865 -0.0273,-0.27344 -0.0911,-0.59245 l 0.36459,-0.54687 0.14583,0.88411 q 0.20052,0.89323 0.53776,1.28516 0.3737,0.4375 1.0573,0.4375 0.20963,0 0.31901,-0.1276 0.11849,-0.13672 0.11849,-0.33724 0,-0.45573 -0.28255,-0.97526 -0.20964,-0.38282 -0.556,-0.76563 l 0.61068,-0.99349 q 0.42839,0.70182 0.51954,0.95703 0.20052,0.57422 0.20052,1.66797 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path127"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text16",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    className: "st3 st4 st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 168.16956,139.47832 H 157.6422 v -1.58594 h 7.4284 q -0.92969,-0.72006 -1.56771,-1.1211 -0.79297,-0.5013 -1.44922,-0.72917 -0.73828,-0.25521 -1.4948,-0.25521 -0.46484,0 -0.9388,0.0638 0.26432,-0.67448 0.69271,-1.08464 0.61979,-0.59245 1.56771,-0.59245 0.92969,0 2.19662,0.91146 0.62891,0.45573 2.05078,1.73177 1.10287,0.9935 1.4948,1.07553 h 0.54687 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 158.28022,139.47832 h -4.08334 q -0.51953,0 -0.9388,-0.30078 -0.41016,-0.30079 -0.41016,-0.71094 0,-0.34636 0.0365,-0.62891 0.0365,-0.28255 0.13672,-0.61979 h 0.20963 q 0.10027,0.3737 0.36459,0.53776 0.21875,0.13672 0.60156,0.13672 h 3.52735 q 0,-1.63152 -0.45573,-2.62501 -0.5651,-1.23958 -1.88672,-1.64974 l 0.13672,-1.76823 q 1.57683,0.77474 2.23308,2.47005 0.52864,1.36719 0.52864,3.57293 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 151.98204,139.47832 h -5.19533 v -1.58594 h 4.52996 q 0,-1.07553 -0.25521,-1.64063 -0.17318,-0.39193 -0.85677,-1.13021 l 0.71094,-1.48568 q 0.65625,0.82943 0.82031,1.29427 0.2461,0.70183 0.2461,2.32423 z m -0.082,1.80469 -0.67448,1.32162 -1.4948,-0.76563 0.69271,-1.32162 z m -2.07813,0.84766 -0.6836,1.30338 -1.50391,-0.77474 0.71094,-1.3125 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 147.42474,139.47832 h -4.08335 q -0.51953,0 -0.9388,-0.30078 -0.41016,-0.30079 -0.41016,-0.71094 0,-0.34636 0.0365,-0.62891 0.0365,-0.28255 0.13672,-0.61979 h 0.20964 q 0.10026,0.3737 0.36458,0.53776 0.21875,0.13672 0.60156,0.13672 h 3.52736 q 0,-1.63152 -0.45573,-2.62501 -0.56511,-1.23958 -1.88673,-1.64974 l 0.13672,-1.76823 q 1.57683,0.77474 2.23308,2.47005 0.52865,1.36719 0.52865,3.57293 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path118"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3 73.3l-5.5-15.7c-2.2.8-3.8 2.2-4.7 4.2-1 2-1.1 4.1-.4 6.4.6 1.8 1.6 3.1 3 4.1 1.4 1 3 1.5 4.7 1.5 1 .1 2-.1 2.9-.5zM166.9 58.7c-1.5-1-3.1-1.5-4.8-1.5-.9 0-1.8.2-2.7.5l5.5 15.7c2.2-.8 3.9-2.2 4.8-4.2 1-2 1.1-4.1.3-6.4-.7-1.8-1.7-3.2-3.1-4.1zM169.5 199.7c-1-2-2.6-3.4-4.7-4.2l-5.5 15.7c1 .4 1.9.5 2.8.5 1.8-.1 3.3-.6 4.7-1.5s2.4-2.3 3-4.1c.8-2.3.7-4.4-.3-6.4zM97.4 195.6c-.9-.3-1.8-.5-2.7-.5-1.8 0-3.4.5-4.8 1.5s-2.4 2.3-3 4.1c-.8 2.2-.7 4.4.3 6.4s2.6 3.4 4.8 4.2l5.4-15.7z",
    id: "path18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M631.6 43.2h-33.7c-.1 0-1.2 1.9-3.2 5.7-2.1 3.8-4.4 9.6-7.1 17.2s-5 17.2-7.1 28.5c-2 11.4-3.1 24.7-3.2 39.8.1 15.1 1.2 28.4 3.2 39.8 2.1 11.4 4.4 21 7.1 28.6 2.7 7.7 5 13.4 7.1 17.2 2 3.9 3.1 5.8 3.2 5.8h33.7c-.1 0-1.2-1.9-3.2-5.8-2.1-3.8-4.4-9.6-7.1-17.2-2.7-7.7-5-17.2-7.1-28.6-2-11.4-3.1-24.7-3.2-39.8.1-15.1 1.2-28.4 3.2-39.8 2.1-11.4 4.4-20.9 7.1-28.5 2.7-7.7 5-13.4 7.1-17.2 2-3.8 3.1-5.7 3.2-5.7z",
    className: "st1",
    id: "path20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M632.4 43.6l.7-1.1h-35.5l-.2.2c-.1.1-1.2 2-3.3 5.9-2 3.9-4.4 9.7-7.1 17.3-2.7 7.7-5.1 17.2-7.1 28.7-2.1 11.4-3.2 24.7-3.3 39.9.1 15.2 1.2 28.5 3.3 39.9 2 11.5 4.4 21 7.1 28.7 2.7 7.7 5.1 13.4 7.1 17.3 2.1 3.9 3.2 5.9 3.3 5.9l.2.4h35.5l-.7-1.3c-.1 0-.2-.1-.4-.2-.6-.9-2-3.5-4.1-7.7-2.1-4.3-4.3-10.2-6.8-17.8-2.5-7.5-4.6-16.8-6.5-27.7-1.8-10.9-2.8-23.4-2.8-37.5.1-15.1 1.2-28.3 3.2-39.6 2-11.4 4.3-20.9 7-28.5 2.7-7.6 5-13.3 7.1-17.1 1-1.8 1.8-3.2 2.4-4.2.2-.5.4-.9.5-1.1.2-.3.3-.5.4-.4m-6.7 9.6c-2.1 4.6-4.3 10.6-6.7 18.2-2.4 7.5-4.4 16.5-6 27.1-1.7 10.6-2.6 22.6-2.6 36 .1 13.6.9 25.7 2.6 36.3 1.7 10.6 3.7 19.6 6.1 27.2 2.4 7.6 4.6 13.7 6.7 18.2 2.1 4.6 3.7 7.6 4.6 9h-32.2c-.6-.9-2-3.5-4.1-7.7-2.1-4.3-4.3-10.2-6.8-17.8-2.5-7.5-4.6-16.8-6.5-27.7-1.8-10.9-2.8-23.4-2.8-37.5.1-15.1 1.2-28.3 3.2-39.6s4.3-20.9 7-28.5c2.8-7.6 5.2-13.3 7.1-17.1 1-1.8 1.8-3.2 2.4-4.2.2-.5.4-.9.5-1.1h32.1c-.9 1.5-2.5 4.6-4.6 9.2z",
    id: "path22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M665.3 43.2h-33.7c-.1 0-1.2 1.9-3.2 5.7-2.1 3.8-4.4 9.6-7.1 17.2s-5 17.2-7.1 28.5c-2 11.4-3.1 24.7-3.2 39.8.1 15.1 1.2 28.4 3.2 39.8 2.1 11.4 4.4 21 7.1 28.6 2.7 7.7 5 13.4 7.1 17.2 2 3.9 3.1 5.8 3.2 5.8h33.7c-.1 0-1.2-1.9-3.2-5.8-2.1-3.8-4.4-9.6-7.1-17.2-2.7-7.7-5-17.2-7.1-28.6-2-11.4-3.1-24.7-3.2-39.8.1-15.1 1.2-28.4 3.2-39.8 2.1-11.4 4.4-20.9 7.1-28.5 2.7-7.7 5-13.4 7.1-17.2 2-3.8 3.1-5.7 3.2-5.7z",
    className: "st2",
    id: "path24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M665.9 43.6l.9-1.1h-35.5l-.2.2c-.1.1-1.2 2-3.3 5.9-2 3.9-4.4 9.7-7.1 17.3-2.7 7.7-5.1 17.2-7.1 28.7-2.1 11.4-3.2 24.7-3.3 39.9.1 15.2 1.2 28.5 3.3 39.9 2 11.5 4.4 21 7.1 28.7 2.7 7.7 5.1 13.4 7.1 17.3 2.1 3.9 3.2 5.9 3.3 5.9l.2.4h35.5l-.9-1.3c.1 0 0-.1-.2-.2-.6-.9-2-3.5-4.1-7.7-2.1-4.3-4.3-10.2-6.8-17.8-2.5-7.5-4.6-16.8-6.5-27.7-1.8-10.9-2.8-23.4-2.8-37.5.1-15.1 1.2-28.3 3.2-39.6 2-11.4 4.3-20.9 7-28.5 2.7-7.6 5-13.3 7.1-17.1 1-1.8 1.8-3.2 2.4-4.2.2-.5.4-.9.5-1.1l.2-.4m-6.6 9.6c-2.1 4.6-4.3 10.6-6.6 18.2-2.3 7.5-4.3 16.5-6 27.1-1.6 10.6-2.5 22.6-2.6 36 .1 13.6.9 25.7 2.6 36.3 1.7 10.6 3.7 19.6 6 27.2 2.4 7.6 4.6 13.7 6.7 18.2 2.1 4.6 3.7 7.6 4.6 9h-32c-.6-.9-2-3.5-4.1-7.7-2.1-4.3-4.3-10.2-6.8-17.8-2.5-7.5-4.6-16.8-6.5-27.7-1.8-10.9-2.8-23.4-2.8-37.5.1-15.1 1.2-28.3 3.2-39.6s4.3-20.9 7-28.5c2.7-7.6 5-13.3 7.1-17.1 1-1.8 1.8-3.2 2.4-4.2.2-.5.4-.9.5-1.1h32c-1 1.5-2.6 4.6-4.7 9.2z",
    id: "path26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text28",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    className: "st3 st4 st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 606.17535,139.47832 h -5.19532 v -1.58594 h 4.52995 q 0,-1.07553 -0.25521,-1.64063 -0.17317,-0.39193 -0.85677,-1.13021 l 0.71094,-1.48568 q 0.65625,0.82943 0.82031,1.29427 0.2461,0.70183 0.2461,2.32423 z m -0.72006,-8.42189 -0.71093,1.32161 -1.47657,-0.76562 0.67448,-1.33073 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 601.61805,139.47832 h -10.52737 v -1.58594 h 7.4284 q -0.92969,-0.72006 -1.56771,-1.1211 -0.79297,-0.5013 -1.44922,-0.72917 -0.73828,-0.25521 -1.49479,-0.25521 -0.46485,0 -0.93881,0.0638 0.26433,-0.67448 0.69271,-1.08464 0.61979,-0.59245 1.56771,-0.59245 0.92969,0 2.19662,0.91146 0.62891,0.45573 2.05079,1.73177 1.10286,0.9935 1.49479,1.07553 h 0.54688 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 591.72871,139.47832 h -1.27605 q -0.61979,0 -0.99349,-0.50131 -0.32812,-0.4375 -0.5013,-1.30338 -0.16406,-0.86589 -0.25521,-2.13282 -0.0547,-1.02995 -0.11849,-2.11459 -0.0547,-1.08463 -0.15495,-1.64062 -0.0911,-0.56511 -0.2552,-0.92058 -0.20053,-0.4375 -0.556,-0.76563 l 1.1211,-1.76823 q 0.35547,1.09375 0.5013,2.61589 0.0912,0.94792 0.1823,4.48439 0.16406,1.62239 0.47395,2.07812 0.25521,0.38282 0.55599,0.38282 h 1.27605 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 587.44485,139.47832 h -0.72006 q -0.54687,0 -0.96615,-0.14584 -0.41015,-0.15494 -0.83854,-0.48307 -0.38281,0.34635 -0.68359,0.46484 -0.42839,0.16407 -1.2487,0.16407 h -1.1211 q 0,0.83854 -0.40104,1.63151 -0.51953,1.02995 -1.58594,1.63151 -1.33985,0.75652 -3.35418,0.75652 -1.82292,0 -2.78906,-0.63803 -1.0573,-0.70182 -1.0573,-2.15104 0,-0.78386 0.19141,-1.58594 0.19141,-0.80209 0.51953,-1.61329 0.20052,-0.49218 0.69271,-1.51302 l 0.36459,0.16406 q -0.63803,1.31251 -0.84766,2.06902 -0.20052,0.75651 -0.20052,1.38542 0,1.13021 0.80208,1.72266 0.8112,0.58333 2.306,0.58333 1.75,0 3.1263,-0.61068 1.71355,-0.75651 1.71355,-2.11459 0,-0.91146 -0.33724,-1.73177 -0.26433,-0.64714 -0.7474,-1.23958 l 0.75651,-1.8685 q 0.45573,0.7474 0.6198,1.32162 0.22786,0.8112 0.22786,2.21485 h 1.1211 q 0.86588,0 1.23047,-0.26433 0.31901,-0.22786 0.31901,-0.70182 0,-0.26432 -0.0365,-0.52865 -0.0273,-0.27344 -0.0911,-0.59245 l 0.36459,-0.54687 0.14583,0.88411 q 0.20052,0.89323 0.53776,1.28516 0.3737,0.4375 1.0573,0.4375 0.20963,0 0.31901,-0.1276 0.11849,-0.13672 0.11849,-0.33724 0,-0.45573 -0.28256,-0.97526 -0.20963,-0.38282 -0.55599,-0.76563 l 0.61068,-0.99349 q 0.42839,0.70182 0.51953,0.95703 0.20053,0.57422 0.20053,1.66797 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text30",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    className: "st3 st4 st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 638.16955,139.47832 h -10.52736 v -1.58594 h 7.4284 q -0.92969,-0.72006 -1.56772,-1.1211 -0.79297,-0.5013 -1.44922,-0.72917 -0.73828,-0.25521 -1.49479,-0.25521 -0.46485,0 -0.93881,0.0638 0.26433,-0.67448 0.69271,-1.08464 0.6198,-0.59245 1.56772,-0.59245 0.92968,0 2.19661,0.91146 0.62891,0.45573 2.05079,1.73177 1.10287,0.9935 1.49479,1.07553 h 0.54688 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 628.28021,139.47832 h -4.08334 q -0.51954,0 -0.93881,-0.30078 -0.41015,-0.30079 -0.41015,-0.71094 0,-0.34636 0.0365,-0.62891 0.0365,-0.28255 0.13672,-0.61979 h 0.20964 q 0.10026,0.3737 0.36458,0.53776 0.21875,0.13672 0.60157,0.13672 h 3.52735 q 0,-1.63152 -0.45573,-2.62501 -0.56511,-1.23958 -1.88672,-1.64974 l 0.13671,-1.76823 q 1.57683,0.77474 2.23308,2.47005 0.52865,1.36719 0.52865,3.57293 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 621.98202,139.47832 h -5.19532 v -1.58594 h 4.52996 q 0,-1.07553 -0.25521,-1.64063 -0.17318,-0.39193 -0.85678,-1.13021 l 0.71094,-1.48568 q 0.65625,0.82943 0.82032,1.29427 0.24609,0.70183 0.24609,2.32423 z m -0.082,1.80469 -0.67448,1.32162 -1.49479,-0.76563 0.6927,-1.32162 z m -2.07813,0.84766 -0.68359,1.30338 -1.50391,-0.77474 0.71094,-1.3125 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 617.42472,139.47832 h -4.08334 q -0.51953,0 -0.9388,-0.30078 -0.41016,-0.30079 -0.41016,-0.71094 0,-0.34636 0.0365,-0.62891 0.0365,-0.28255 0.13672,-0.61979 h 0.20963 q 0.10026,0.3737 0.36459,0.53776 0.21875,0.13672 0.60156,0.13672 h 3.52735 q 0,-1.63152 -0.45573,-2.62501 -0.56511,-1.23958 -1.88672,-1.64974 l 0.13672,-1.76823 q 1.57682,0.77474 2.23307,2.47005 0.52865,1.36719 0.52865,3.57293 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path82"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M662.4 61.8c-1-2-2.6-3.4-4.8-4.2l-5.3 15.7c1 .4 1.9.5 2.8.5 1.8-.1 3.3-.6 4.7-1.5 1.4-1 2.4-2.3 3-4.1.7-2.2.6-4.4-.4-6.4zM590.5 57.7c-.9-.3-1.8-.5-2.7-.5-1.8 0-3.4.5-4.8 1.5-1.5 1-2.5 2.3-3.2 4.1-.7 2.2-.6 4.4.5 6.4 1 2 2.5 3.4 4.6 4.2l5.6-15.7zM590.3 211.2l-5.3-15.7c-2.2.8-3.9 2.2-4.8 4.2-1 2-1.2 4.1-.5 6.4.6 1.8 1.6 3.1 3 4.1 1.4 1 2.9 1.5 4.6 1.5 1.1 0 2.1-.2 3-.5zM659.8 196.6c-1.5-1-3.1-1.5-4.8-1.5-.9 0-1.8.2-2.7.5l5.6 15.7c2.1-.8 3.7-2.2 4.6-4.2s1.1-4.1.5-6.4c-.7-1.8-1.7-3.2-3.2-4.1z",
    id: "path32"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M375 43.2h-33.5v182.7H375v-23-68.4-91.3z",
    className: "st1",
    id: "path34"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M375.7 48.9v-6.4h-35v184.2h35v-.7-23-68.4-68.3-17.4m-1.4-4.9v181.3h-32.1v-26.5-64.2-68.3V49v-4.9h32.1z",
    id: "path36"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M408.7 43.2H375v182.7h33.7v-23-68.4-91.3z",
    className: "st2",
    id: "path38"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M409.5 48.9v-6.4h-35.2v184.2h35.2v-.7-23-68.4-68.3-17.4M408 44v181.3h-32.2v-26.5-64.2-68.3V49v-4.9H408z",
    id: "path40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text42",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    className: "st3 st4 st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 370.17538,139.47832 h -5.19532 v -1.58594 h 4.52995 q 0,-1.07553 -0.25521,-1.64063 -0.17317,-0.39193 -0.85677,-1.13021 l 0.71094,-1.48568 q 0.65625,0.82943 0.82031,1.29427 0.2461,0.70183 0.2461,2.32423 z m -0.72006,-8.42189 -0.71093,1.32161 -1.47657,-0.76562 0.67448,-1.33073 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 365.61808,139.47832 h -10.52737 v -1.58594 h 7.4284 q -0.92969,-0.72006 -1.56771,-1.1211 -0.79297,-0.5013 -1.44922,-0.72917 -0.73828,-0.25521 -1.49479,-0.25521 -0.46485,0 -0.93881,0.0638 0.26433,-0.67448 0.69271,-1.08464 0.6198,-0.59245 1.56771,-0.59245 0.92969,0 2.19662,0.91146 0.62891,0.45573 2.05079,1.73177 1.10286,0.9935 1.49479,1.07553 h 0.54688 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 355.72874,139.47832 h -1.27604 q -0.6198,0 -0.9935,-0.50131 -0.32812,-0.4375 -0.5013,-1.30338 -0.16406,-0.86589 -0.25521,-2.13282 -0.0547,-1.02995 -0.11849,-2.11459 -0.0547,-1.08463 -0.15495,-1.64062 -0.0911,-0.56511 -0.2552,-0.92058 -0.20053,-0.4375 -0.556,-0.76563 l 1.1211,-1.76823 q 0.35547,1.09375 0.5013,2.61589 0.0911,0.94792 0.1823,4.48439 0.16406,1.62239 0.47395,2.07812 0.25521,0.38282 0.556,0.38282 h 1.27604 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 351.44488,139.47832 h -0.72006 q -0.54687,0 -0.96615,-0.14584 -0.41015,-0.15494 -0.83854,-0.48307 -0.38281,0.34635 -0.68359,0.46484 -0.42839,0.16407 -1.2487,0.16407 h -1.1211 q 0,0.83854 -0.40104,1.63151 -0.51953,1.02995 -1.58594,1.63151 -1.33985,0.75652 -3.35417,0.75652 -1.82292,0 -2.78907,-0.63803 -1.0573,-0.70182 -1.0573,-2.15104 0,-0.78386 0.19141,-1.58594 0.19141,-0.80209 0.51953,-1.61329 0.20052,-0.49218 0.69271,-1.51302 l 0.36459,0.16406 q -0.63803,1.31251 -0.84766,2.06902 -0.20052,0.75651 -0.20052,1.38542 0,1.13021 0.80208,1.72266 0.8112,0.58333 2.306,0.58333 1.75,0 3.1263,-0.61068 1.71355,-0.75651 1.71355,-2.11459 0,-0.91146 -0.33724,-1.73177 -0.26432,-0.64714 -0.7474,-1.23958 l 0.75651,-1.8685 q 0.45573,0.7474 0.6198,1.32162 0.22786,0.8112 0.22786,2.21485 h 1.1211 q 0.86588,0 1.23047,-0.26433 0.31901,-0.22786 0.31901,-0.70182 0,-0.26432 -0.0365,-0.52865 -0.0273,-0.27344 -0.0911,-0.59245 l 0.36459,-0.54687 0.14583,0.88411 q 0.20052,0.89323 0.53776,1.28516 0.3737,0.4375 1.0573,0.4375 0.20963,0 0.31901,-0.1276 0.11849,-0.13672 0.11849,-0.33724 0,-0.45573 -0.28256,-0.97526 -0.20963,-0.38282 -0.55599,-0.76563 l 0.61068,-0.99349 q 0.42839,0.70182 0.51953,0.95703 0.20053,0.57422 0.20053,1.66797 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path109"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text44",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    className: "st3 st4 st5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 406.35576,139.47832 h -10.52737 v -1.58594 h 7.4284 q -0.92969,-0.72006 -1.56771,-1.1211 -0.79297,-0.5013 -1.44922,-0.72917 -0.73828,-0.25521 -1.49479,-0.25521 -0.46485,0 -0.93881,0.0638 0.26433,-0.67448 0.69271,-1.08464 0.61979,-0.59245 1.56771,-0.59245 0.92969,0 2.19662,0.91146 0.62891,0.45573 2.05079,1.73177 1.10286,0.9935 1.49479,1.07553 h 0.54688 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 396.46642,139.47832 h -4.08335 q -0.51953,0 -0.9388,-0.30078 -0.41016,-0.30079 -0.41016,-0.71094 0,-0.34636 0.0365,-0.62891 0.0365,-0.28255 0.13672,-0.61979 h 0.20964 q 0.10026,0.3737 0.36458,0.53776 0.21875,0.13672 0.60156,0.13672 h 3.52735 q 0,-1.63152 -0.45573,-2.62501 -0.5651,-1.23958 -1.88672,-1.64974 l 0.13672,-1.76823 q 1.57683,0.77474 2.23308,2.47005 0.52865,1.36719 0.52865,3.57293 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 390.16823,139.47832 h -5.19532 v -1.58594 h 4.52995 q 0,-1.07553 -0.25521,-1.64063 -0.17317,-0.39193 -0.85677,-1.13021 l 0.71094,-1.48568 q 0.65625,0.82943 0.82031,1.29427 0.2461,0.70183 0.2461,2.32423 z m -0.082,1.80469 -0.67448,1.32162 -1.4948,-0.76563 0.69271,-1.32162 z m -2.07813,0.84766 -0.6836,1.30338 -1.50391,-0.77474 0.71094,-1.3125 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 385.61093,139.47832 h -4.08334 q -0.51954,0 -0.93881,-0.30078 -0.41015,-0.30079 -0.41015,-0.71094 0,-0.34636 0.0365,-0.62891 0.0365,-0.28255 0.13672,-0.61979 h 0.20964 q 0.10026,0.3737 0.36458,0.53776 0.21875,0.13672 0.60157,0.13672 h 3.52735 q 0,-1.63152 -0.45573,-2.62501 -0.56511,-1.23958 -1.88673,-1.64974 l 0.13672,-1.76823 q 1.57683,0.77474 2.23308,2.47005 0.52865,1.36719 0.52865,3.57293 z",
    style: {
      fontSize: "18.6667px",
      fontFamily: "Arial-BoldMT",
      direction: "rtl",
      fill: "#ffffff"
    },
    id: "path100"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M341.5 74.2V57.7c-2.4.1-4.4.9-5.9 2.4-1.6 1.6-2.4 3.6-2.5 6 .1 2.3.9 4.3 2.5 5.8 1.5 1.5 3.5 2.3 5.9 2.3zM414.6 60.1c-1.6-1.6-3.6-2.4-5.9-2.5v16.6c2.4-.1 4.3-.9 5.9-2.4 1.6-1.6 2.4-3.5 2.5-5.8-.1-2.4-.9-4.4-2.5-5.9zM341.5 211.7v-16.8c-2.4.1-4.4.9-5.9 2.5-1.6 1.6-2.4 3.6-2.5 5.9.1 2.4.9 4.3 2.5 5.9 1.5 1.6 3.5 2.4 5.9 2.5zM414.6 197.4c-1.6-1.6-3.6-2.4-5.9-2.5v16.8c2.4-.1 4.3-.9 5.9-2.5 1.6-1.6 2.4-3.6 2.5-5.9-.1-2.4-.9-4.4-2.5-5.9z",
    id: "path46"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133 246.1c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st6",
    id: "path48"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904951,1.0009514)",
    id: "text50",
    style: {
      fontSize: "13.3333px",
      fontFamily: "ArialMT",
      fill: "#ffffff",
      strokeWidth: 0.99905
    },
    className: "st3 st7 st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 126.0023,259.4212 v -8.6263 q -0.29948,0.29948 -1.01563,0.67057 -0.70963,0.3711 -1.3151,0.52084 v -1.25 q 0.80078,-0.22136 1.71224,-0.70313 0.91146,-0.48828 1.39974,-0.91797 h 0.48177 v 10.30599 z",
    style: {
      fontSize: "13.3333px",
      fontFamily: "ArialMT",
      fill: "#ffffff",
      strokeWidth: 0.99905
    },
    id: "path73"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M382.7 246.1c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st6",
    id: "path52"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904951,1.0009514)",
    id: "text54",
    style: {
      fontSize: "13.3333px",
      fontFamily: "ArialMT",
      fill: "#ffffff",
      strokeWidth: 0.99905
    },
    className: "st3 st7 st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 377.78208,251.9798 q 0,-0.8138 -0.51432,-1.27604 -0.51432,-0.46875 -1.39974,-0.46875 -0.625,0 -1.26302,0.31901 -0.63802,0.31901 -1.19141,0.91145 v -1.23697 q 0.4948,-0.51433 1.1198,-0.78776 0.63151,-0.27344 1.47786,-0.27344 1.36719,0 2.20052,0.73567 0.83333,0.72917 0.83333,1.97917 0,1.11328 -0.51432,1.92708 -0.50781,0.81381 -1.74479,1.66667 -1.26302,0.8724 -1.69271,1.25 -0.42318,0.37761 -0.59245,0.72266 -0.16927,0.34505 -0.16927,0.83984 h 5.01302 v 1.13281 h -6.34114 v -0.5013 q 0,-0.87239 0.23437,-1.47786 0.24089,-0.61198 0.78776,-1.1849 0.54688,-0.57943 1.70573,-1.38672 1.1849,-0.83333 1.61459,-1.45833 0.43619,-0.63151 0.43619,-1.43229 z",
    style: {
      fontSize: "13.3333px",
      fontFamily: "ArialMT",
      fill: "#ffffff",
      strokeWidth: 0.99905
    },
    id: "path70"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M640.3 246.1c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st6",
    id: "path56"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904951,1.0009514)",
    id: "text58",
    style: {
      fontSize: "13.3333px",
      fontFamily: "ArialMT",
      fill: "#ffffff",
      strokeWidth: 0.99905
    },
    className: "st3 st7 st8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 631.00533,257.73501 q 1.03516,0.80078 2.33724,0.80078 1.04167,0 1.64714,-0.50782 0.61197,-0.51432 0.61197,-1.37369 0,-1.91407 -2.74088,-1.91407 h -0.83984 v -1.05468 h 0.80078 q 2.42838,0 2.42838,-1.79688 0,-1.66015 -1.85547,-1.66015 -1.06119,0 -1.99869,0.71614 v -1.20443 q 0.98958,-0.57291 2.31119,-0.57291 1.28907,0 2.07032,0.67708 0.78125,0.67057 0.78125,1.74479 0,1.97917 -2.01823,2.54558 v 0.026 q 1.09375,0.11718 1.72526,0.77474 0.63802,0.65104 0.63802,1.6276 0,1.36068 -0.98308,2.19401 -0.97656,0.83333 -2.60416,0.83333 -1.43229,0 -2.3112,-0.53385 z",
    style: {
      fontSize: "13.3333px",
      fontFamily: "ArialMT",
      fill: "#ffffff",
      strokeWidth: 0.99905
    },
    id: "path67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem40Ar);
export default __webpack_public_path__ + "static/media/item40ar.99c28f658c2cbf9e7c55700897bd36e3.svg";
export { ForwardRef as ReactComponent };